export const APPOINTMENT_DETAILS_TITLE = "Session Details";

export const SECTION_LABELS = {
  APPOINTMENT_STATUS: "Session Status",
  PAYMENT_STATUS: "Payment Status",
  CLIENT_INFO: "Client Information",
  YOUR_INFO: "Your Information",
  SCHEDULE_AND_LOCATION: "Schedule & Location",
  DATE_AND_TIME: "Date & Time",
  DURATION: "Duration",
  LOCATION: "Location",
  MEETING_LINK: "Meeting Link",
  MESSAGE: "Message",
  NAME: "Name",
  EMAIL: "Email",
  PHONE: "Phone",
  PRACTITIONER: "Practitioner",
};

export const STATUS_CHIP_CONFIG = {
  confirmed: {
    label: "Confirmed",
    bgcolor: "#4CAF50",
    color: "white",
  },
  cancelled: {
    label: "Cancelled",
    bgcolor: "#F44336",
    color: "white",
  },
  rescheduled: {
    label: "Rescheduled",
    bgcolor: "#9C27B0",
    color: "white",
  },
  pending: {
    label: "Pending",
    bgcolor: "#FF9800",
    color: "white",
  },
  new: {
    label: "Pending",
    bgcolor: "#FF9800",
    color: "white",
  },
  completed: {
    label: "Completed",
    bgcolor: "#2196F3",
    color: "white",
  },
  showed: {
    label: "Completed",
    bgcolor: "#2196F3",
    color: "white",
  },
  noshow: {
    label: "No Show",
    bgcolor: "#9E9E9E",
    color: "white",
  },
  no_show: {
    label: "No Show",
    bgcolor: "#9E9E9E",
    color: "white",
  },
};

export const PAYMENT_CHIP_CONFIG = {
  paid: {
    label: "Paid",
    bgcolor: "#4CAF50",
    color: "white",
    icon: "CheckCircle",
  },
  freeConsultation: {
    label: "Free Consultation",
    bgcolor: "#8B4513",
    color: "white",
    icon: "CardGiftcard",
  },
  paymentPending: {
    label: "Payment Pending",
    bgcolor: "#FF9800",
    color: "white",
    icon: "Pending",
  },
};

export const DATE_DISPLAY_OPTIONS = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

export const TIME_DISPLAY_OPTIONS = {
  hour: "2-digit",
  minute: "2-digit",
  timeZoneName: "short",
};

export const FOLLOW_UP_COPY = {
  freeConsultation:
    "This is your complimentary first consultation. Schedule a follow-up session to continue your journey.",
  default:
    "Ready to continue? Schedule your next session with your practitioner.",
};

export const FOLLOW_UP_COPY_PRACTITIONER = {
  freeConsultation:
    "This is the client's complimentary first consultation. Schedule a follow-up session to continue their care.",
  default:
    "Schedule a follow-up session with this client. A scheduling window will open with their details pre-filled.",
};

export const FOLLOW_UP_BUTTON_TEXT = "Schedule Follow-up Session";
export const CLOSE_BUTTON_TEXT = "Close";
export const MINUTES_LABEL = "minutes";
export const N_A = "N/A";

export const CHARGE_PATIENT_MESSAGE =
  "This session requires payment. Charge the client's card on file for the session duration.";
export const CHARGE_PATIENT_BUTTON_TEXT = "Charge Client";

export const RESCHEDULE_BUTTON_TEXT = "Contact Support";
export const CANCEL_BUTTON_TEXT = "Cancel Session";

export const RESCHEDULE_MESSAGE =
  "Need help with your session? Reach out to our support team for assistance.";
export const CANCEL_MESSAGE =
  "Cancel this session. The client will be notified and the time slot will be released.";

export const CONSULTATION_GATE_MESSAGE =
  "Complete your free consultation to unlock follow-up scheduling. Your first consultation is the required first step before booking additional sessions.";

export const AGREEMENT_GATE_MESSAGE =
  "Please sign the Client Participation Agreement to unlock follow-up scheduling.";

export const TELEHEALTH_CONSENT_GATE_MESSAGE =
  "Please sign the Telehealth Informed Consent to unlock follow-up scheduling.";
